import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BranchCard from '../components/BranchCard';
import Button from '../components/Button';

const BranchPage = () => {
  // State for province and city filters
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  
  // Sample branch data
  const branches = [
    {
      id: 1,
      name: 'LP2SDM RTD~CL Pusat',
      location: 'Jl. Terusan Cikutra Baru No. 29',
      city: 'Bandung',
      postalCode: '40124',
      coordinator: 'Ahmad Zubaidi',
      phone: '+62 813-3416-3069',
      whatsappNumber: '6281334163069',
      schedule: [
        'Selasa: 19:00 (Arcamanik)'
      ],
      image: 'https://images.unsplash.com/photo-1565967511849-76a60a516170?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80',
      badgeText: 'BANDUNG',
      badgeColor: 'bg-yellow-500',
      province: 'jawa_barat'
    },
    {
      id: 2,
      name: 'LP2SDM RTD~CL Malang',
      location: 'Jl. Manggar No.7A',
      city: 'Malang',
      postalCode: '65141',
      coordinator: 'Dhany Pahlevi',
      phone: '+62 812-338-7607',
      whatsappNumber: '628123387607',
      schedule: [
        'Selasa: 19:30 (Polinema)',
        'Minggu: 07:30 (Polinema)',
        'Sabtu: 07:00 (GTA)',
        'Kamis: 19:00 (DAU)',
        'Rabu: 19:00 (PCP)',
        'Selasa dan Kamis: (Pasuruan)',
        'Minggu: 07:00 (Blitar)'
      ],
      image: 'https://images.unsplash.com/photo-1583417319070-4a69db38a482?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
      badgeText: 'MALANG RAYA',
      badgeColor: 'bg-green-600',
      province: 'jawa_timur'
    },
    {
      id: 3,
      name: 'LP2SDM RTD~CL Kediri',
      location: 'Jl. Sudirman No. 123',
      city: 'Kediri',
      postalCode: 'xxxxx',
      coordinator: 'Halim',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxxxx',
      schedule: [
        'Minggu: 06:00 (Outdoor)'
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'KEDIRI RAYA',
      badgeColor: 'bg-green-600',
      province: 'jawa_timur'
    },
    {
      id: 4,
      name: 'LP2SDM RTD~CL Tuban',
      location: 'Perhutani KPH Tuban, Jalan Gajah Mada',
      city: 'Tuban',
      postalCode: 'xxxxx',
      coordinator: 'Nurfakih',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxxxx',
      schedule: [
        'Jumat dan Minggu: malam (Perhutani)',
        'Hari: (Jatirogo)',
        'Hari: (Singgahan)'
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'TUBAN',
      badgeColor: 'bg-green-600',
      province: 'jawa_timur'
    },
    {
      id: 5,
      name: 'LP2SDM RTD~CL Surabaya',
      location: 'Aula RS Muji Rahayu Surabaya, Raya Manukan Wetan 68',
      city: 'Surabaya',
      postalCode: 'xxxxx',
      coordinator: 'Arfandy A (boy)',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxxxx',
      schedule: [
        'Selasa: (RS Muji Rahayu)',
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'SURABAYA RAYA',
      badgeColor: 'bg-green-600',
      province: 'jawa_timur'
    },
    {
      id: 6,
      name: 'LP2SDM RTD~CL Yogyakarta',
      location: 'Jl. Tambak Bayan 3 No.20, Babarsari Catur Tunggal, Depok',
      city: 'Sleman',
      postalCode: 'xxxxx',
      coordinator: 'Amin Ja`far Shadiq',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxxxx',
      schedule: [
        'Sabtu: 06:30 (UIN Sunan Kalijaga)',
        'Rabu: 19:00 (Lap. Minggiran Krapyak)',
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'YOGYAKARTA',
      badgeColor: 'bg-blue-600',
      province: 'yogyakarta'
    },
    {
      id: 7,
      name: 'LP2SDM RTD~CL Semarang',
      location: 'Jl. Abu Bakar Tambakaji Kec. Ngaliyan',
      city: 'Semarang',
      postalCode: '50185',
      coordinator: 'Muhammad Mujadedid Hidayat',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxxxx',
      schedule: [
        'Kamis: (Pura Girinata)',
        'Hari: (UIN Walisongo)',
        'Selasa: (Kendal)'
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'SEMARANG',
      badgeColor: 'bg-blue-600',
      province: 'jawa_tengah'
    },
    {
      id: 8,
      name: 'LP2SDM RTD~CL Jakarta',
      location: 'Jl Tomang Tinggi Raya No 15 RT 01 RW 07 Tomang, Grogol Petamburan',
      city: 'Jakarta Barat',
      postalCode: 'xxxxx',
      coordinator: 'Tri Yudianto',
      phone: '+62 812-3456-7890',
      whatsappNumber: '628123456789',
      schedule: [
        'Selasa dan Jumat: (Tomang Raya)',
        'Selasa dan Minggu: (Jakarta Utara)',
        'Selasa dan Minggu: (Bogor)'
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'JAKARTA RAYA',
      badgeColor: 'bg-blue-600',
      province: 'jakarta'
    },
    {
      id: 9,
      name: 'LP2SDM RTD~CL Banyumas',
      location: 'Jl. Balaidesa Kedungwuluh Lor 002/002 Patikraja',
      city: 'Banyumas',
      postalCode: 'xxxxx',
      coordinator: 'Shonnief Hidayat',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxx',
      schedule: [
        'Sabtu: 20:00 (Balaidesa)',
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'BANYUMAS',
      badgeColor: 'bg-blue-600',
      province: 'jawa_tengah'
    },
    {
      id: 10,
      name: 'LP2SDM RTD~CL Lamongan',
      location: 'Jl. Jalan Sore',
      city: 'Lamongan',
      postalCode: 'xxxxx',
      coordinator: 'Budi Santoso',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxxxx',
      schedule: [
        'Hari: Jam (Lokasi)',
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'LAMONGAN',
      badgeColor: 'bg-blue-600',
      province: 'jawa_timur'
    },
    {
      id: 11,
      name: 'LP2SDM RTD~CL Bandar Lampung',
      location: 'Perum Bukit Bayangkara Permai Blok A No.1 Perumahan Beringin Raya, Kec Kemiling',
      city: 'Bandar Lampung',
      postalCode: 'xxxxx',
      coordinator: 'Yahya Arianta Pratama',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '628123456789',
      schedule: [
        'Hari: xx:xx',
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'LAMPUNG',
      badgeColor: 'bg-blue-600',
      province: 'lampung'
    },
    {
      id: 12,
      name: 'LP2SDM RTD~CL Madura',
      location: 'RT 011 RW 006, Dusun Panggung Daja, Desa Bataal Timur, Kec. Ganding',
      city: 'Kab. Sumenep',
      postalCode: 'xxxxx',
      coordinator: 'Sholeh Agus Ribowo',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxxxx',
      schedule: [
        'Minggu: pagi (Unit 1)',
        'Minggu dan Senin: (Unit 2)',
        'Minggu: pagi (Unit 3)'
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'MADURA',
      badgeColor: 'bg-blue-600',
      province: 'jawa_timur'
    },
    {
      id: 13,
      name: 'LP2SDM RTD~CL Banyuwangi',
      location: 'Dusun Curahsawo',
      city: 'Banyuwangi',
      postalCode: 'xxxxx',
      coordinator: 'Muhammad Ruham',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxx',
      schedule: [
        'Selasa dan Jumat (Sidodadi)',
        'Sabtu: (Bimorejo)',
        'Sabtu dan Minggu: (Bondowoso)'
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'BANYUWANGI',
      badgeColor: 'bg-blue-600',
      province: 'jawa_timur'
    },
    {
      id: 14,
      name: 'LP2SDM RTD~CL Banjarmasin',
      location: 'Jl. Mahligai Komp. Boga Tengah Permai blok C no. 13',
      city: 'Banjarmasin',
      postalCode: 'xxxxx',
      coordinator: 'Dr. Ahmad Muradi, M.Ag',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxxx',
      schedule: [
        'Rabu malam dan Sabtu sore (Unit 1)',
        'Kamis malam (Unit 2)',
        'Rabu malam (Unit 3)'
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'BANJARMASIN',
      badgeColor: 'bg-blue-600',
      province: 'kalimantan_selatan'
    },
    {
      id: 15,
      name: 'LP2SDM RTD~CL Denpasar',
      location: 'Jl. Trenggana No. 35 Penatih',
      city: 'Denpasar',
      postalCode: 'xxxxx',
      coordinator: 'I Made Dirga',
      phone: '+62 xxx-xxxx-xxxx',
      whatsappNumber: '62xxxxxxxxxxxxx',
      schedule: [
        'Rabu dan Sabtu: (Unit 1)',
        'Kamis: (Unit 2)',
        'Rabu: malam (Unit 3)'
      ],
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1064&q=80',
      badgeText: 'BALI',
      badgeColor: 'bg-blue-600',
      province: 'bali'
    },
  ];
  
  // Filter branches based on selected province and city
  const filteredBranches = branches.filter(branch => {
    if (selectedProvince && branch.province !== selectedProvince) {
      return false;
    }
    if (selectedCity && branch.city.toLowerCase() !== selectedCity) {
      return false;
    }
    return true;
  });
  
  // Handle search button click
  const handleSearch = () => {
    // In a real app, this might fetch data from an API
    console.log('Searching for branches in:', selectedProvince, selectedCity);
  };
  
  return (
    <div className="font-sans bg-gray-50">
      <Header activePage="branch" />
      
      {/* Cabang Section */}
      <section className="pt-32 pb-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-primary mb-4">Cabang Terdekat</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Temukan cabang LP2SDM RTD~CL di kota Anda dan bergabunglah dengan komunitas lokal
            </p>
          </div>

          {/* City Selection Form */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-12 max-w-4xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-center justify-between">
              <h3 className="text-xl font-bold text-gray-800 mb-4 md:mb-0">Pilih Kota Anda</h3>
              <div className="flex flex-col sm:flex-row gap-4">
                <select 
                  className="border border-gray-300 rounded-md px-4 py-2 bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
                  value={selectedProvince}
                  onChange={(e) => setSelectedProvince(e.target.value)}
                >
                  <option value="">Pilih Provinsi</option>
                  <option value="jakarta">DKI Jakarta</option>
                  <option value="jawa_barat">Jawa Barat</option>
                  <option value="jawa_timur">Jawa Timur</option>
                  <option value="jawa_tengah">Jawa Tengah</option>
                  <option value="yogyakarta">DI Yogyakarta</option>
                  <option value="bali">Bali</option>
                  <option value="lampung">Lampung</option>
                  <option value="kalimantan_selatan">Kalimantan Selatan</option>
                </select>
                <select 
                  className="border border-gray-300 rounded-md px-4 py-2 bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
                  value={selectedCity}
                  onChange={(e) => setSelectedCity(e.target.value)}
                >
                  <option value="">Pilih Kota</option>
                  <option value="jakarta pusat">Jakarta Pusat</option>
                  <option value="bandung">Bandung</option>
                  <option value="malang">Malang</option>
                  <option value="surabaya">Surabaya</option>
                  <option value="yogyakarta">Yogyakarta</option>
                  <option value="semarang">Semarang</option>
                </select>
                <Button onClick={handleSearch}>
                  Cari Cabang
                </Button>
              </div>
            </div>
          </div>

          {/* Branch Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredBranches.map(branch => (
              <BranchCard 
                key={branch.id}
                name={branch.name}
                location={branch.location}
                city={branch.city}
                postalCode={branch.postalCode}
                coordinator={branch.coordinator}
                phone={branch.phone}
                schedule={branch.schedule}
                image={branch.image}
                badgeText={branch.badgeText}
                badgeColor={branch.badgeColor}
                whatsappNumber={branch.whatsappNumber}
                detailLink={`/cabang/${branch.id}`}
              />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BranchPage;
